import { faCircleCheck } from "@fortawesome/pro-regular-svg-icons/faCircleCheck";
import { faCircleX } from "@fortawesome/pro-regular-svg-icons/faCircleX";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip, useTheme } from "@mui/material";
import { AssCorrectionResult } from "generated/CoreApi_v1";
import React from "react";

/////////////////////////////////////////////////////////////////////////////////

interface IProps {
    result?: AssCorrectionResult | null;
    correctAnswer?: string;
}

export const AssRevisionResultIcon: React.FC<IProps> = ({ result, correctAnswer }) => {

    const theme = useTheme();

    return (
        <>
            {
                result == AssCorrectionResult.Correct &&
                    <FontAwesomeIcon icon={faCircleCheck} size="2x" color={theme.palette.success.main} />
            }
            {
                result == AssCorrectionResult.Wrong &&
                    <Tooltip title={correctAnswer}>
                        <FontAwesomeIcon icon={faCircleX} size="2x" color={theme.palette.error.main} />
                    </Tooltip>
            }
        </>
    );
};
